const interfaceTranslations = {
  selectedCountryAriaLabel: "Избрана държава",
  noCountrySelected: "Няма избрана държава",
  countryListAriaLabel: "Списък на страните",
  searchPlaceholder: "Търсене",
  zeroSearchResults: "Няма намерени резултати",
  oneSearchResult: "Намерен е 1 резултат",
  multipleSearchResults: "${count} намерени резултата",
  // additional countries (not supported by country-list library)
  ac: "Остров Възнесение",
  xk: "Косово"
};
export default interfaceTranslations;